export default {
  payWelfareText: 'Beneficios de recarga',
  blackFridayDiscount: 'Descuento limitado de Black Friday',
  shareGift: 'Compartir regalo',
  vipWeeklyWelfare: 'Descuento semanal VIP',
  exchangeCoupon: 'Cupón',
  firstPayOff: 'Hasta un 15% de descuento en la 1.ª compra',
  blackFridayEvent: 'Evento de Black Friday',
  limitedTimeOff: '10% de descuento por tiempo limitado',
  claimCoupon: 'Reclamar ahora',
  blackFridayTimedCoupon: 'Cupón limitado de Black Friday',
  timeLeft: 'Tiempo restante: ',
  claimTimeCoupon: '¡Reclamar ya el cupón del 10% de descuento!',
  points: 'Puntos: ${point}',
  costPointTip: 'Canjear puntos por cupones',
  maxPointTip: 'Cada cuenta puede usar hasta 500 puntos.',
  discountOff: '10% de descuento',
  highestDiscount: 'Hasta ${discount} de descuento',
  needPoint: 'Se necesitan ${point} ptos',
  changeCurrency: 'Cambiar moneda',
  claim: 'Reclamar',
  claimSucc: 'Reclamado',
  claimFail: 'Fallido',
  pointNotEnough: 'Puntos insuficientes',
  afterClaimPoint: 'Puntos restantes: ${point}',
  footTips1: 'Solo se puede usar 1 cupón por orden.',
  footTips2:
    'El cupón no se puede usar para comprar monedas o tokens del juego.',
  footTips3:
    ' Nos reservamos el derecho a dar una interpretación final de este evento.',
  ruleTitleText: 'Reglas del evento',
  ruleTime:
    'Duración del evento: Del 24 de nov. 2023, 00:00, al 26 de nov. 2023, 23:59 (UTC)',
  bfRuleText1:
    '1. Se te acreditarán 400 puntos en tu cuenta cuando te conectes a la página oficial de recargas por primera vez durante el evento. Podrás canjear hasta 500 puntos por cupones.',
  bfRuleText2:
    '2. Podrás canjear los puntos del Black Friday por cupones durante el evento.',
  bfRuleText3:
    '3. Solo se puede usar 1 cupón por orden. No se pueden usar cupones para comprar monedas ni tokens del juego.',
  bfRuleText4:
    '4. Para las transacciones, solo aceptamos las siguientes monedas:',
  ableCoinsType: '/',
  bfRuleText5:
    '5. No se pueden cambiar la moneda una vez realizada la transacción. Los puntos canjeados no se pueden reembolsar.',
  bfRuleText6: '6. Los cupones del Black Friday tendrán validez solo por 7 días.',
  bfRuleText7:
    '7. Nos reservamos el derecho a dar una interpretación final de este evento.',
  thanksTip:
    'Gracias por participar. Únete a nuestra comunidad oficial para obtener más información sobre el evento.',
  exchangePoints: 'Intercambiar',
  exchangeCode: 'Ingresa el código de cambio.',
  enterExchangeCode: 'Ingresa el código de cambio.',
  exchangeText: 'Intercambiar',
  confirmGet: 'Confirmar',
  couponUsedWay:
    'El cupón solo se puede usar con ciertas divisas. Confirma primero la moneda a usar.',
  confirmText: 'Confirmar',
  exchangeSucc: 'Canjeado',
  aboutCoins: 'Sobre las monedas/tokens del juego',
  aboutCoinsText:
    'Podrás canjear las monedas y tokens del juego por todos los paquetes y privilegios, pero no por la propia moneda/token del juego.',
  known: 'OK',
  codeText: 'Código',
  codeInvalid: '¡Código no válido!',
  hasExchanged: 'No puedes reclamar más códigos.',
  hideText: 'Ocultar',
  //黑五的报错码
  'bf-20001': 'No se ha iniciado sesión',
  'bf-20002': 'Error de parámetro. Intenta ingresar de nuevo al evento.',
  'bf-20003': 'Puntos insuficientes',
  'bf-20004':
    '¡Falló! Vuelve a intentarlo más tarde o ponte en contacto con el servicio de atención al cliente.',
  'bf-20005': 'Reclamado',
  'bf-20015': 'El evento no está disponible actualmente.',
  'bf-20016': 'El evento ya terminó.',
  bfShareText: '¡Reclamar ya el cupón del 10% de descuento!',
  rightsCenterBtn: 'Centro de miembros premium',
  payBtn: 'RECARGAS',
  hasEqualRewardMuglo: '¡Un BONUS de hasta 1800 diamantes del sitio web oficial de recargas!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Gloria extraordinaria (permanente)',
  rightCenterNoticeTitle: 'El sistema de puntos VIP se actualizará al Centro de Privilegios',
  rightCenterNoticeContent: "¡Hola, comandante!<br />Gracias por seguir apoyándonos. Para ofrecer una experiencia de recompensas aún mejor, el 26/6/2025 el actual sistema de puntos VIP se actualizará y pasará al nuevo Centro de privilegios. Este novedoso sistema no solo consolidará los beneficios VIP existentes, sino que también introducirá una serie de ventajas nuevas y emocionantes. A continuación te contamos lo que debes saber:<br />1. Cambios<br />Los beneficios del inicio de sesión semanal se mantienen<br />Del 26 de junio al 9 de julio de 2025, los jugadores podrán seguir reclamando Cupones VIP semanales al iniciar sesión en la página oficial de recargas. La cantidad de cupones será la misma que en el evento de Puntos VIP. Además, los jugadores podrán canjear nuevos cupones en el Centro de privilegios, que incluirán un tope máximo de descuento. Para conocer todos los detalles sobre las nuevas normas de los cupones y los límites de canje, consulta la tabla al final de este aviso.<br />Nota: La función de canje automático de cupones debe activarse manualmente. Para hacerlo, ve a la página principal del Centro de privilegios > Beneficios de miembros > Activar Canjear cupones automáticamente > Seleccionar cupones para el canje automático > Confirmar.<br />Nueva función de intercambio de puntos<br />El Centro de privilegios ofrecerá una función de intercambio de puntos. Gana puntos iniciando sesión en el juego o completando las tareas designadas; luego, canjéalos por cupones exclusivos, objetos raros y otras recompensas valiosas. (Consulta la página del Centro de privilegios para ver los límites de canje de objetos)<br />Herencia de nivel VIP<br />Tu nivel VIP actual y los Puntos VIP acumulados se transferirán completamente al nuevo sistema. Se te asignará automáticamente el nivel correspondiente en el Centro de privilegios, y todos tus beneficios VIP actuales se mantendrán e incluso mejorarán.<br />2. Razones por las que esta actualización es mejor<br />Beneficios más claros: Todas las reglas de recompensas y detalles de canje se muestran con mayor claridad, por lo que es más fácil reclamar tus beneficios.<br />Mayores recompensas: Disfruta de nuevos eventos de intercambio de puntos y de objetos de gran valor actualizados regularmente.<br />Sorteos de la suerte: Además del canje de puntos, también habrá eventos de sorteos que te darán la oportunidad de ganar valiosos objetos del juego.<br />3. Notas importantes<br />Durante el período de transición (del 26 de junio al 9 de julio de 2025), la sección original de Puntos VIP se irá eliminando gradualmente. Podrás seguir recibiendo y usando cupones como de costumbre durante este tiempo. Asegúrate de usar los cupones restantes antes de que finalice el Evento de Puntos VIP, ya que los cupones sin usar caducarán cuando se cierre.<br />Cuando el Centro de privilegios esté disponible, podrás acceder a él yendo a Centro oficial de recargas > Toca tu avatar > Centro de privilegios",
  rightCenterNoticeTableTitle: 'Comparación de cambios en cupones',
  rightCenterNoticeTableHeader1: 'Requisitos de canje - Nivel de membresía prémium',
  rightCenterNoticeTableHeader2: 'Nivel VIP original',
  rightCenterNoticeTableHeader3: 'Descuento del cupón',
  rightCenterNoticeTableHeader4: 'Límite de adquisición',
  rightCenterNoticeTableHeader5: 'Límite máximo de descuento',
  rightCenterNoticeTableLevel1: 'Bronce',
  rightCenterNoticeTableLevel2: 'Plata',
  rightCenterNoticeTableLevel3: 'Oro',
  rightCenterNoticeTableLevel4: 'Platino',
  rightCenterNoticeTableLevel5: 'Diamante',
  rightCenterNoticeTableCount1: 'Una vez al día',
  rightCenterNoticeTableCount2: '15 veces/mes',
  rightCenterNoticeTableCount3: '10 veces/mes',
  rightCenterNoticeTableLimit: '15 $',
  rightCenterNoticeTableTip: 'Nota: Los límites de descuento de los cupones del Centro de privilegios son en USD y pueden fluctuar con los tipos de cambio. El importe real del descuento se mostrará en la página de uso.',
  '-': '-'
};
